var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVelvetcapitallogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "lpag97fmsa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B6FEB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#623CD3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "url(#lpag97fmsa)",
    strokeWidth: 3,
    fill: "#FFF",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11h2.62l6.398 12.215L31.363 11H34l-7.413 14.21H23.45z",
    fill: "#564DD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 39.421h2.62l6.398-12.215 6.345 12.215H34l-7.413-14.21H23.45z",
    fill: "#BE82F3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelvetcapitallogo2);
export default __webpack_public_path__ + "static/media/velvetcapitallogo2.e7839911de122fab4d531687ec42cfe6.svg";
export { ForwardRef as ReactComponent };